import { useCallback, useState } from "react";

import {
  ChatHistoryItem,
  GetChatByIdResult,
  GetUserChatHistoryResult,
} from "@/types/chat-history";

import { useApi } from "../useApi";

const useAdminChatHistory = () => {
  const [items, setItems] = useState<ChatHistoryItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const { apiGet } = useApi({ isAdmin: true });

  const loadAdminChatHistory = useCallback(
    async (userId: string) => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiGet<GetUserChatHistoryResult>(
          `/admin/chat-history?userId=${userId}`
        );
        if (response?.items) {
          setItems(response.items);
        } else {
          setError("Failed to load chat history");
        }
      } catch (error) {
        console.error(error);
        setError("Failed to load chat history");
      } finally {
        setLoading(false);
      }
    },
    [apiGet]
  );

  const getAdminChatById = useCallback(
    async (
      userId: string,
      chatId: string
    ): Promise<GetChatByIdResult | null> => {
      setLoading(true);
      setError(null);

      try {
        const response = await apiGet<GetChatByIdResult>(
          `/admin/chat-history?userId=${userId}&conversationId=${chatId}`
        );
        setLoading(false);
        return response;
      } catch (error) {
        console.error(error);
        setError("Failed to load chat details");
        setLoading(false);
        return null;
      }
    },
    [apiGet]
  );

  return {
    items,
    loading: loading,
    error,
    loadAdminChatHistory,
    getAdminChatById,
  };
};

export default useAdminChatHistory;